export const readSessionStorageItem = key => {
  if (typeof window !== 'undefined') {
    const stored = window.sessionStorage.getItem(key);
    if (stored) {
      return JSON.parse(stored);
    }
  }
  return null;
};

export const writeSessionStorageItem = (key, value) => {
  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  }
};

export const removeSessionStorageItem = key => {
  if (typeof window !== 'undefined') {
    window.sessionStorage.removeItem(key);
  }
};
